import { RoutePair } from "../../types/FilterEntitys";
import { gql, useQuery } from "@apollo/client";
import { RoutePairFilterQuery } from "@/gql/graphql";

export const routePairFilterQuery = gql`
  fragment seaAreaStatusOwn on SeaArea {
    id
    name
  }
  query RoutePairFilter {
    productPrice {
      routePair {
        allWithStatusOwn {
          id
          code
          seaArea {
            ...seaAreaStatusOwn
          }
        }
      }
    }
  }
`;

export const useFetchAllRoutePairs = () => {
  const { data, loading, error, refetch } = useQuery<RoutePairFilterQuery>(
    routePairFilterQuery,
    { fetchPolicy: "cache-first" }
  );
  const allRoutePairs =
    data?.productPrice.routePair.allWithStatusOwn.map<RoutePair>((r) => ({
      id: r.id,
      code: r.code,
      name: r.code,
      seaArea: r.seaArea,
    })) ?? [];
  return { allRoutePairs, loading, error, refetch };
};
